import React from 'react';
import { Collapse } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { isObject } from 'lodash';
import FieldProvider from '../../Fields/Provider';
import CustomField from '../../Fields/CustomField';
import FieldProviderServiceId from '../../Fields/ProviderServiceId';

import { checkShowField } from './helper';
import { getProvider } from '../../../../../helpers/getters';

const ProviderField = ({
  isLoading,
  error,
  providerId,
  providerServiceId,
  customFieldsValues,
  onChangeProviderId,
  onChangeProviderServiceId,
  onChangeCustomField,
  form,
  modal,
  providerForm,
  refill,
}) => {
  const providerServiceIdParam = providerForm?.provider_service_id;
  const provider = getProvider(providerId);

  const showForm = provider?.form;
  const collapseInt = !!(providerForm || providerServiceIdParam);

  return (
    <>
      <FieldProvider form={form} modal={modal} providerId={providerId} isLoading={isLoading} onChange={onChangeProviderId} refill={refill} />
      {error ? <div className="alert alert-danger">{error}</div> : null}
      {showForm
        ? (
          <Collapse
            in={collapseInt}
          >
            <div>
              {providerServiceIdParam
                ? (
                  <FieldProviderServiceId
                    {...providerServiceIdParam}
                    form={form}
                    modal={modal}
                    providerServiceId={providerServiceId}
                    onChange={onChangeProviderServiceId}
                    refill={refill}
                  />
                ) : null}
              {providerForm
                ? Object.values(providerForm)
                  .map((providerCustomFiled, index) => {
                    if (!isObject(providerCustomFiled)) {
                      return null
                    }
                    const { name, dependent } = providerCustomFiled;
                    if (name === 'provider_service_id') {
                      return null;
                    }
                    if (dependent) {
                      const showField = checkShowField(providerServiceId, providerServiceIdParam, providerCustomFiled);
                      if (!showField) {
                        return null;
                      }
                    }
                    const value = customFieldsValues && customFieldsValues.hasOwnProperty(name) ? customFieldsValues[name] : null;
                    return (
                      <CustomField
                        key={index}
                        value={value}
                        onChange={onChangeCustomField}
                        refill={refill}
                        {...providerCustomFiled}
                      />
                    )
                  }) : null}
            </div>
          </Collapse>
        ) : null}
    </>
  );
};

ProviderField.propTypes = {
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  providerId: PropTypes.number,
  providerServiceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  customFieldsValues: PropTypes.any,
  onChangeProviderId: PropTypes.func,
  onChangeProviderServiceId: PropTypes.func,
  onChangeCustomField: PropTypes.func,
  providerForm: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  form: PropTypes.object,
  modal: PropTypes.object,
  refill: PropTypes.bool,
}

export default ProviderField;
